import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { DataService } from '../data.service';
import { AgencyMaster } from '../../shared/common-components/common-structure';
import { CustomerOrganization } from '../../features/agencytspsearch/agencytspsearch';
import {  catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgencyMasterService extends DataService {

  private baseURI = this.apiUri + '/agencymaster/';

  public agencyMasterFormState = new BehaviorSubject<any>(null);

  constructor(http: HttpClient) {
    super(http);
  }

  /*
    Purpose of this function is to get all agency users based on agency code and bureau code
  */
  getAgencyUsersByAgencyCodeAndBureauCode(agencycode: string, bureaucode: string): Observable<CustomerOrganization[]> {
    this.setUri(this.baseURI + agencycode + '/agencycode/' + bureaucode + '/bureaucode');
    return this.get().pipe(catchError(this.handleError));
  }

  /*
    Purpose of this function is to get all agency users based on agency code and bureau code
  */
 getAgencyBureauNameByAgencyCode(agencycode: string): Observable<AgencyMaster> {
  this.setUri(this.baseURI + agencycode + '/agencycode/bureauaszero');
  return this.get().pipe(catchError(this.handleError));
}

  /*
    Purpose of this function is to get all agency users
  */
  getAllAgency(): Observable<AgencyMaster[]> {
    this.setUri(this.baseURI);
    return this.get().pipe(catchError(this.handleError));
  }

  /*
    Purpose of this function is to get all bureau users based on agency users
  */
  getAllBureauByAgency(agencycode: string): Observable<AgencyMaster[]> {
    this.setUri(this.baseURI + agencycode + '/agencycode');
    return this.get().pipe(catchError(this.handleError));
  }

  getDetailsByAgencyMasterId(agencyMasterId: number): Observable<AgencyMaster>{
    this.setUri(this.baseURI + agencyMasterId + '/agencymasterid');
    return this.get().pipe(catchError(this.handleError));
  }

  /**
   * @description egt agency bureau code details using organization id.
   * @param orgId: id of the organization
   */
  getAgencyBureauDetails(orgId): Observable<any> {
   //  http://localhost:8380/tmssserver/api/public/agencymaster/1312/orgId
      return this.http.get(this.baseURI + orgId + '/orgId');
  }

}
